import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Building2 } from "lucide-react";
import { motion } from "framer-motion";
import logo from "@/assets/logo.png";

const Footer = () => {
  return (
    <footer className="bg-white text-black py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <img src={logo} alt="Ramborgh Invest" width={120} height={40} loading="lazy" decoding="async" className="h-10 w-auto mb-4" />
            <p className="text-black/70 text-sm leading-relaxed">
              Din sikre og pålidelige partner til køb og salg af CS2 skins. Vi tilbyder de bedste priser og den mest sikre handelsoplevelse.
            </p>
          </motion.div>

          {/* Navigation Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <h3 className="text-lg font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/koeb-skins" className="text-black/70 hover:text-black transition-colors text-sm">
                  Køb Skins
                </Link>
              </li>
              <li>
                <Link to="/saelg-skins" className="text-black/70 hover:text-black transition-colors text-sm">
                  Sælg Skins
                </Link>
              </li>
              <li>
                <Link to="/kontakt-os" className="text-black/70 hover:text-black transition-colors text-sm">
                  Kontakt Os
                </Link>
              </li>
            </ul>
          </motion.div>

          {/* Support Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h3 className="text-lg font-semibold mb-4">Support</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/faq" className="text-black/70 hover:text-black transition-colors text-sm">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/blogs" className="text-black/70 hover:text-black transition-colors text-sm">
                  Blogs
                </Link>
              </li>
              <li>
                <Link to="/privatlivspolitik" className="text-black/70 hover:text-black transition-colors text-sm">
                  Privatlivspolitik
                </Link>
              </li>
              <li>
                <Link to="/handelsbetingelser" className="text-black/70 hover:text-black transition-colors text-sm">
                  Handelsbetingelser
                </Link>
              </li>
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <h3 className="text-lg font-semibold mb-4">Kontakt</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-black/70" />
                <a href="mailto:ramborgh@gmail.com" className="text-black/70 hover:text-black transition-colors text-sm">
                  ramborgh@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-black/70" />
                <a href="tel:+4542228209" className="text-black/70 hover:text-black transition-colors text-sm">
                  42 22 82 09
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="w-4 h-4 text-black/70" />
                <span className="text-black/70 text-sm">Sandbygårdvej 23, 2700 Brønshøj, Danmark</span>
              </li>
              <li className="flex items-center gap-2">
                <Building2 className="w-4 h-4 text-black/70" />
                <span className="text-black/70 text-sm">CVR: 42 78 19 03</span>
              </li>
            </ul>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="border-t border-black/20 pt-6 mt-6"
        >
          <p className="text-black/50 text-sm text-center">
            © {new Date().getFullYear()} Ramborgh Invest. Alle rettigheder forbeholdes.
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
